import { Scale } from "@pdfking/math"

import type { CalendarDesign } from "#internal"

import { Slice } from "../../layout/Slice"
import { Area } from "../Area"
import { PictureCover } from "../PictureCover"
import { Region } from "../Region"

/** Kaushan, a long desk calendar: the year up the left of its picture; a month's picture on its right, the contact, its name and its grid left of it. */
export const Kaushan: CalendarDesign = {
  cover: PictureCover({ vertical: true }),
  page: ({ gap, language, outer, page, short, year }, month) => {
    const picture = Region(page, 0.68, 0, 1, 1)
    const [contact, rest] = Slice.top(Slice.before(outer, picture.x, gap), Scale(short, 0.12), gap)
    return [
      Area.picture(picture, month),
      Area.footer(contact),
      ...Area.month(rest, month, year, language, Scale(short, 0.08), gap),
    ]
  },
  pages: "month",
}
